module.exports = __webpack_public_path__ + "static/img/icon2.3989bc1c.png";